import {
  MeasurementRangeFragment,
  MeasurementUnits,
  QualifiedFeature,
} from "fe-common/graphql";
import { RecursivePartial } from "fe-common/commonTypes/types";
import { DURATION_FEATURE_ID, Relations } from "shared";

export type RangeBuilder = (
  val: number,
  unit: MeasurementUnits,
) => MeasurementRangeFragment;

export type RangeExtractor = (
  range: MeasurementRangeFragment,
) => { value: number; unit: MeasurementUnits };

export const singleValueRangeBuilder: RangeBuilder = (val, unit) => ({
  low: val,
  high: val,
  units: unit,
  complexUnits: null,
});

export const defaultRangeValueExtractor: RangeExtractor = (
  range: MeasurementRangeFragment,
) => {
  return { value: range.low, unit: range.units };
};

//TODO: the client should get the feature and relation full object from the server
export function buildDurationQF(
  durationQf: QualifiedFeature,
  range: MeasurementRangeFragment,
): RecursivePartial<QualifiedFeature> {
  return {
    ...durationQf,
    qualifiers: [
      ...durationQf.qualifiers,
      {
        name: "Duration",
        value: {
          id: DURATION_FEATURE_ID,
        },
        relation: {
          name: "Duration",
          id: Relations.DURATION,
        },
        range: range,
      },
    ],
  };
}
